var exports = {
  "Nr": "x9245d464--c533f7--card",
  "e0": "x9245d464--c533f7--top-content",
  "WD": "x9245d464--c533f7--labels",
  "Mn": "x9245d464--c533f7--provider",
  "wm": "x9245d464--c533f7--logo",
  "eB": "x9245d464--c533f7--bottom-content",
  "pz": "x9245d464--c533f7--two-lines",
  "Fm": "x9245d464--c533f7--factoid",
  "dD": "x9245d464--c533f7--changed-value",
  "nO": "x9245d464--c533f7--changed-value-icon",
  "Bz": "x9245d464--c533f7--factoid-row-title",
  "k9": "x9245d464--c533f7--factoid-row-value",
};

module.exports = exports;
